import { z } from 'my-zod'
import {
  AdditionalWaiverQuestionType,
  predefinedQuestionKeyOptions
} from '../../outfitter-operations/outfitter-waiver-content'

export const additionalWaiverQuestionResponse = z
  .object({
    questionId: z.string(),
    questionType: AdditionalWaiverQuestionType,
    prompt: z.string(),
    answer: z.union([z.string().max(160), z.boolean(), z.array(z.string())]).nullish(),
    predefinedQuestionKey: z.enum(predefinedQuestionKeyOptions).nullable()
  })
  .superRefine((val, ctx) => {
    const requiredTypes: AdditionalWaiverQuestionType[] = [
      'checkboxRequired',
      'textRequired',
      'dropdownRequired',
      'multiselectRequired'
    ]

    if (requiredTypes.includes(val.questionType)) {
      const isEmpty =
        val.answer === null ||
        val.answer === undefined ||
        val.answer === '' ||
        (Array.isArray(val.answer) && val.answer.length === 0)

      if (isEmpty) {
        ctx.addIssue({
          code: 'custom',
          message: 'Required',
          path: ['answer']
        })
      }
    }
  })

export function getDefaultAnswersByQuestionType(questionType: AdditionalWaiverQuestionType) {
  if (questionType === 'checkboxOptional' || questionType === 'checkboxRequired') {
    return false
  } else if (
    questionType === 'dropdownOptional' ||
    questionType === 'dropdownRequired' ||
    questionType === 'multiselectOptional' ||
    questionType === 'multiselectRequired'
  ) {
    return []
  } else if (questionType === 'textOptional' || questionType === 'textRequired') {
    return ''
  } else {
    throw new Error('Incorrect question type')
  }
}
